import React from "react";
import { UserPlus, Users, BookOpen, ShoppingCart } from "lucide-react";

const STATS = [
  { icon: UserPlus, value: "40,000+", label: "Dentists onboarded" },
  { icon: Users, value: "8,000+", label: "Active users" },
  { icon: BookOpen, value: "1,500+", label: "Courses" },
  { icon: ShoppingCart, value: "10,000+", label: "Products in catalog" },
];

const Stats = () => (
  <section className="bg-white py-16 md:py-20 border-y border-slate-100">
    <div className="max-w-[1200px] mx-auto px-6">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
        {STATS.map((s) => (
          <div key={s.label} className="text-center">
            <div className="w-14 h-14 rounded-2xl bg-[#E6F7F5] text-[#14B8A6] mx-auto mb-3 flex items-center justify-center">
              <s.icon size={22} />
            </div>
            <div
              className="text-3xl md:text-4xl font-extrabold text-[#0F2A5F] mb-1"
              style={{ fontFamily: "'Open Sans', sans-serif" }}
            >
              {s.value}
            </div>
            <div className="text-xs md:text-sm text-slate-500 uppercase tracking-wider">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Stats;
